import exportLang from './export'
import tokens from './tokens'

export default {
    exportLang,
    tokens
}